import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import useManagedField from './queries/useManagedField';
import colours from '../../tokens/colours';
import fontSizes from '../../tokens/fontSizes';
import TextInput from './TextInput';
import { EyeIcon } from '../index';
import P from '../../atoms/P';
import Feedback from '../Feedback';
const TOGGLE_TEXT_WIDTH = 92;
const getStyles = createUseStyles({
    root: {
        position: 'relative',
        marginTop: 8,
        paddingRight: 83
    },
    toggleButton: {
        position: 'absolute',
        top: 16,
        right: TOGGLE_TEXT_WIDTH + 8,
        height: 24,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: colours.quarternary
        }
    },
    toggleIcon: {
        width: 16,
        height: 'auto',
        margin: [4, 4, 0, 4]
    },
    toggleText: {
        opacity: 0,
        padding: 4,
        fontSize: fontSizes.Small,
        lineHeight: '1.6rem',
        backgroundColor: colours.quarternary,
        color: colours.primary,
        width: TOGGLE_TEXT_WIDTH,
        textAlign: 'center',
        position: 'absolute',
        top: 16,
        right: 0,
        transition: ['opacity', '0.2s', 'linear']
    },
    toggleTextActive: {
        opacity: 1
    },
    error: {
        borderColor: '#E0032A',
        backgroundColor: 'rgba(224,3,42,0.051)',
        '&:focus': {
            borderColor: '#E0032A',
        }
    }
});
const PasswordInput = ({ className, ...rest }) => {
    const styles = getStyles();
    const [inputType, setInputType] = useState('password');
    const [hover, setHover] = useState(false);
    const onTogglePassword = () => {
        if (inputType === 'password') {
            setInputType('text');
        }
        else {
            setInputType('password');
        }
    };
    return (React.createElement("div", { className: classNames(styles.root, className) },
        React.createElement(TextInput, { type: inputType, ...rest }),
        React.createElement("button", { className: styles.toggleButton, onClick: onTogglePassword, type: 'button', onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) },
            React.createElement(EyeIcon, { fill: '#4E4E61', className: styles.toggleIcon })),
        React.createElement(P, { className: classNames(styles.toggleText, { [styles.toggleTextActive]: hover }) }, inputType === 'password' ? 'show password' : 'hide password')));
};
const ManagedPasswordInput = (props) => {
    const { meta: { error, isTouched, isValidating }, inputProps, } = useManagedField(props);
    return (React.createElement(React.Fragment, null,
        !isValidating && isTouched && error && (React.createElement(Feedback, { type: 'error' }, error)),
        React.createElement(PasswordInput, { ...inputProps })));
};
PasswordInput.Managed = ManagedPasswordInput;
export default PasswordInput;
//# sourceMappingURL=PasswordInput.js.map